// internal deps
import { PaymentGroupData, PaymentGroupMeta, PaymentMethod, PaymentMethodMeta } from "@swiggy-private/payment-ui";
import { VALID_PAYMENT_GROUP_TYPES } from "@swiggy-private/payment-types";

// interfaces
import { GetPaymentMethodsResponse } from "@payment-client/interfaces/PaymentApi";

export function isCreditCardEMIGroup(
    group: PaymentGroupData<PaymentGroupMeta, PaymentMethod<PaymentMethodMeta>>,
): group is PaymentGroupData<PaymentGroupMeta, PaymentMethod<PaymentMethodMeta>> {
    return group.groupName.toUpperCase() === VALID_PAYMENT_GROUP_TYPES.EMI;
}

export function getEMIPaymentGroup(
    paymentGroups: GetPaymentMethodsResponse["paymentGroup"],
): PaymentGroupData<PaymentGroupMeta, PaymentMethod<PaymentMethodMeta>> | undefined {
    return paymentGroups.find(isCreditCardEMIGroup);
}

export const getEMIPaymentMethodData = (
    emiPaymentGroupData: PaymentGroupData<PaymentGroupMeta, PaymentMethod<PaymentMethodMeta>>,
): PaymentMethod<PaymentMethodMeta> | undefined => {
    return emiPaymentGroupData.paymentMethods.find(method => method.enabled);
};

export const isCreditCardEMIPaymentMethod = (method: PaymentMethod<PaymentMethodMeta>): boolean => {
    return [VALID_PAYMENT_GROUP_TYPES.EMI].includes(method.groupName.toUpperCase());
};
